export default __webpack_public_path__ + "static/media/mechanical.18df2fe8.jpg";